<template>
  <div class="prize-banner">
    <img :src="bannerSrc" :alt="alt" class="prize-banner-img" />
  </div>
</template>

<script>
// In-game promo banners. The artwork carries its own copy (no hardcoded prize
// amount), so swapping a placement to a different banner is just a `type` change.
const BANNERS = {
  predictor: require('@/assets/banners/man-predictor-banner.webp'),
  'predictor-picks': require('@/assets/banners/woman-predictor-banner.webp'),
  'predictor-results': require('@/assets/banners/predictor-results-banner.webp'),
  trivia: require('@/assets/banners/woman-trivia-banner.webp'),
  'trivia-results': require('@/assets/banners/trivia-results-banner.webp'),
};

const ALTS = {
  predictor: 'Test your knowledge by predicting',
  'predictor-picks': 'Test your knowledge by predicting',
  'predictor-results': 'Climb the ladder - play to increase your rank',
  trivia: 'Do you know ball? Test your knowledge',
  'trivia-results': 'Climb the ladder - play to increase your rank',
};

export default {
  name: 'PrizeBanner',
  props: {
    type: {
      type: String,
      default: 'predictor',
      validator: (v) => Object.keys(BANNERS).includes(v),
    },
  },
  computed: {
    bannerSrc() {
      return BANNERS[this.type] || BANNERS.predictor;
    },
    alt() {
      return ALTS[this.type] || 'League XI';
    },
  },
};
</script>

<style scoped>
.prize-banner {
  width: 100%;
  margin-bottom: 16px;
  overflow: hidden;
}

.prize-banner-img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
